<header
  class="Nav__Wrapper"
  [ngClass]="headerClass"
  (mousedown)="disableClickFocus($event)"
  data-test-id="navigationWrapper"
>
  <a
    href="#main-site-content"
    (click)="skipToMain($event)"
    class="Nav__SkipLink"
    [innerHTML]="'Skip to Main Content'"
  ></a>

  @if (!config.hideToolbar) {
    <nav-toolbar
      [config]="config"
      [data]="data"
      [activeLangKey]="activeLangKey"
      (dropdownOptionSelected)="selectOption($event)"
      (navItemClicked)="handleLinkClicked($event)"
      (languageSwitched)="handleLanguageSwitched($event)"
      data-test-id="navigationToolbar"
    >
    </nav-toolbar>
  }

  <nav class="Nav">
    <div class="container u-maxY">
      <div class="u-flex u-alignCenter u-maxY">
        @if (data.isUserLoggedIn) {
          <div
            class="Nav__Toggle"
            tabindex="0"
            (keyup.enter)="toggleMobileMenu(true)"
          >
            <icon
              class="Nav__flyout__toggle__icon"
              name="hamburger"
              [config]="{
                type: 'pointer',
                fill: 'nav-menu-toggle-color',
              }"
              (click)="toggleMobileMenu(true)"
            >
            </icon>
          </div>
        }

        <ds-link
          class="Nav__Logo Nav__Logo--MarginRight"
          data-test-id="navigationLogo"
          tabindex="0"
          [linkConfig]="homeUrl"
          (linkClicked)="handleLinkClicked(homeUrl)"
        ></ds-link>

        @if (config?.showCoBrandLogo) {
          <ds-link
            class="Nav__Logo Nav__Logo--CoBrandLogo Nav__Logo--MarginRight"
            data-test-id="navigationCoBrandLogo"
            tabindex="0"
            [linkConfig]="homeUrl"
            (linkClicked)="handleLinkClicked(homeUrl)"
          ></ds-link>
        }

        @if (!data.isMobileMenuOpen) {
          @if (data.isUserLoggedIn) {
            <nav-links
              class="u-maxY"
              [config]="config"
              [data]="data"
              [externalSiteModalConfig]="externalSiteModalConfig"
              (navItemClicked)="handleLinkClicked($event)"
              data-test-id="navigationLink"
            >
            </nav-links>
          }
          <nav-buttons
            class="u-fillRemaining u-maxY"
            [config]="config"
            [data]="data"
            (contactUsButtonClicked)="toggleContactUs()"
            (loginClicked)="login()"
            (logoutClicked)="logout()"
            data-test-id="navigationButtons"
          >
          </nav-buttons>
        }
        <nav-icons
          (navItemClicked)="handleLinkClicked($event)"
          (navMenuToggled)="navMenuToggled.emit($event)"
          [data]="data"
          class="Nav__Icons--Mobile"
        >
        </nav-icons>
      </div>
    </div>
  </nav>
</header>

<nav-mobile-menu
  [config]="config"
  [data]="data"
  [externalSiteModalConfig]="externalSiteModalConfig"
  [activeLangKey]="activeLangKey"
  (dropdownOptionSelected)="selectOption($event)"
  (navItemClicked)="handleLinkClicked($event)"
  (mobileMenuToggled)="toggleMobileMenu($event)"
  (contactUsButtonClicked)="toggleContactUs()"
  (loginClicked)="login()"
  (logoutClicked)="logout()"
  (languageSwitched)="handleLanguageSwitched($event)"
  data-test-id="navigationMobileMenu"
>
</nav-mobile-menu>

<nav-contact-us
  data-test-id="navigationContactUs"
  [config]="config"
  [isOpen]="isContactUsModalOpen"
  (closeButtonClicked)="toggleContactUs()"
>
</nav-contact-us>

@if (data.openMenuItem; as openMenuItem) {
  <div
    class="Nav__Mask"
    (click)="onNavMaskClick()"
    (keydown.space)="onNavMaskKeydownSpace()"
  ></div>
}
